import {
  ArticleDetailsResponse,
  ArticlesResponse,
  IArticle,
  IWrapper,
} from '../types';
import {PagingPayload} from '../constants';

/**
 * ArticleEnpoint class implements IArticle interface
 */
class ArticleEnpoint implements IArticle {
  readonly wrapper: IWrapper;

  /**
   * Constructor
   * @param {IWrapper} wrapper - The wrapper instance
   */
  constructor(wrapper: IWrapper) {
    this.wrapper = wrapper;
  }

  /**
   * Get articles
   * @return {Promise<ArticlesResponse>}
   */
  public getArticles(articleType: string): Promise<ArticlesResponse> {
    return this.wrapper.get<ArticlesResponse>(`/v2/articles?type=${articleType ? articleType.toUpperCase() : ""}`, PagingPayload);
  }

  /**
   * Get article details
   * @param {string} articleId
   * @return {Promise<ArticleDetailsResponse>}
   */
  public getArticleDetails(articleId: string): Promise<ArticleDetailsResponse> {
    return this.wrapper.get<ArticleDetailsResponse>(
      `/v2/articles/${articleId}`,
    );
  }
}

export default ArticleEnpoint;
